import { AddNewGame } from "./components/AddNewGame";

export default AddNewGame;
